import { useSyncExternalStore } from 'react';
import { subscribeAuthError, getAuthErrorSnapshot, resetReauthGuard } from '@/lib/apiClient';

/**
 * Visible auth-error surface. Renders only after the ONE permitted interactive re-auth has been
 * spent and a gated /api call 401s again (the alternative is a silent dead page or a redirect
 * storm). Try again is the named explicit reset: it re-arms the single re-auth and reloads.
 *
 * Styled with the ClariCommand editorial palette (crimson ink on a crimson-bg strip) rather than
 * raw Tailwind reds, so it reads as part of the same design system.
 */
export function AuthErrorBanner() {
  const hasError = useSyncExternalStore(subscribeAuthError, getAuthErrorSnapshot);
  if (!hasError) return null;
  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        insetInline: 0,
        top: 0,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        padding: '8px 16px',
        background: 'var(--crimson)',
        color: 'var(--paper)',
        fontSize: 13,
        fontWeight: 600,
      }}
    >
      <span>Your sign-in could not be confirmed. Press Try again to sign in.</span>
      <button
        type="button"
        className="btn btn-sm"
        style={{ background: 'transparent', color: 'var(--paper)', borderColor: 'var(--paper)' }}
        onClick={() => {
          resetReauthGuard();
          window.location.reload();
        }}
      >
        Try again
      </button>
    </div>
  );
}
